import { useState } from 'react';
import { requestScreenShareStream } from '../utils/screenShareCapture';

/**
 * Custom hook for screen share detection and management
 */
const useScreenShare = () => {
  const [screenShareActive, setScreenShareActive] = useState(false);
  const [screenStream, setScreenStream] = useState(null);
  const [error, setError] = useState(null);

  /**
   * Request screen share from the user
   * @returns {Promise<MediaStream>} Screen share stream
   */
  const detectScreenShare = async () => {
    try {
      const stream = await requestScreenShareStream();

      setScreenStream(stream);
      setScreenShareActive(true);
      setError(null);

      // Listen for when user stops sharing
      stream.getVideoTracks()[0].onended = () => {
        setScreenShareActive(false);
        setScreenStream(null);
      };

      return stream;
    } catch (err) {
      console.error('[useScreenShare] getDisplayMedia rejected:', err?.name, err?.message, err);
      setScreenShareActive(false);
      setScreenStream(null);
      const message = err?.message || 'Screen sharing is required to view questions';
      setError(message);
      throw new Error(message);
    }
  };

  /**
   * Stop screen sharing
   */
  const stopScreenShare = () => {
    if (screenStream) {
      screenStream.getTracks().forEach(track => track.stop());
      setScreenStream(null);
      setScreenShareActive(false);
    }
  };

  return {
    screenShareActive,
    screenStream,
    error,
    detectScreenShare,
    stopScreenShare,
  };
};

export default useScreenShare;
